import { render, staticRenderFns } from "./RelatedForm.vue?vue&type=template&id=3254842b&scoped=true&lang=pug"
import script from "./RelatedForm.vue?vue&type=script&lang=ts"
export * from "./RelatedForm.vue?vue&type=script&lang=ts"
import style0 from "./RelatedForm.vue?vue&type=style&index=0&id=3254842b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254842b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3254842b')) {
      api.createRecord('3254842b', component.options)
    } else {
      api.reload('3254842b', component.options)
    }
    module.hot.accept("./RelatedForm.vue?vue&type=template&id=3254842b&scoped=true&lang=pug", function () {
      api.rerender('3254842b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/Related/RelatedForm.vue"
export default component.exports